import React from 'react';

const UpgradeTag = ({text}) => {
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '4px 12px',
        backgroundColor: '#F3E8FF',
        color: '#6B21A8',
        fontWeight: 600,
        borderRadius: '20px',
        fontFamily: 'sans-serif',
        fontSize: '14px',
        border: '1px solid #E0D7F0', // Subtle border to match the design's soft edge
        marginLeft: '6px',
      }}
    >
      <svg
        style={{
          display: 'inline-block',
          verticalAlign: 'middle',
          marginRight: '4px',
          width: '12px',
          height: '12px',
        }}
        fill="none"
        stroke="#6B21A8"
        viewBox="0 0 24 24"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
      </svg>
      {text}
    </span>
  );
};

export default UpgradeTag;
